import dayjs from "dayjs";
import { getLocal } from "./storage";

const checkForDate = (monthArray, day) => {
  const len = monthArray.length;
  let lastDate = undefined;

  for (let i = 0; i <= len - 1; i++) {
    const date = monthArray[len - i - 1];
    const dateObj = dayjs(date.date, "YYYY-MM-DD");
    const isDateAvailable = dateObj.format("dddd") === day;

    if (isDateAvailable) {
      lastDate = date.date;
      break;
    }
  }
  return lastDate;
};

const findLastAvailableDate = (data, months, day) => {
  let lastDateFound = "";
  let mon = [...months];

  for (let i = 0; i <= mon.length - 1; i++) {
    const monthArray = data[mon[i]];
    let date = checkForDate(monthArray, day);

    if (date) {
      lastDateFound = date;
      break;
    }
  }
  return lastDateFound;
};

export const getLastMarketDates = (array) => {
  const data = {};
  const months = new Set();

  array.forEach((date) => {
    const d = date.split("-");
    const prev = data[d[1]] || [];

    months.add(d[1]);

    data[d[1]] = [...prev, { day: d[2], date: date }];
  });

  const lastTuesday = findLastAvailableDate(data, months, "Tuesday");
  const lastThursday = findLastAvailableDate(data, months, "Thursday");

  return { lastTuesday, lastThursday };
};

const isHolidayDate = (day, holiday) => {
  let status = false;

  if (holiday && holiday.length > 0) {
    for (let i = 0; i < holiday.length; i++) {
      const holidayDate = new Date(holiday[i].formattedDate);

      if (
        holidayDate.getFullYear() === day.getFullYear() &&
        day.getMonth() === holidayDate.getMonth() &&
        day.getDate() === holidayDate.getDate()
      ) {
        status = true;
        break;
      }
    }
  }

  return status;
};

const getFormattedDateReturn = (date) => {
  let dateFormatted = ("0" + date.getDate()).slice(-2);
  let monthFormatted = ("0" + (parseInt(date.getMonth()) + 1)).slice(-2);

  return date.getFullYear() + "-" + monthFormatted + "-" + dateFormatted;
};

export const isMarketTime = (holidaysData, specialSessionsData) => {
  const format = "HH:mm";

  const time = dayjs(dayjs().format("HH:mm"), format);
  const beforeTime = dayjs("09:00", format);
  const afterTime = dayjs("15:30", format);

  const specialSessionToday = isSpecialSession(specialSessionsData);
  const weekend = specialSessionToday ? [] : ["Sat", "Sun"];
  const day = dayjs().format("ddd");

  const isWeekend = weekend.includes(day) ? true : false;

  if (specialSessionToday) return true;
  if (isWeekend) return false;

  try {
    const todayStr = dayjs().format("YYYY-MM-DD");
    const h = holidaysData || {};
    const holidayList = Array.isArray(h) ? h : (h.NFO || []);
    
    if (holidayList.some((d) => d.formattedDate === todayStr)) {
      return false;
    }
  } catch (e) {}

  return time.isAfter(beforeTime) && time.isBefore(afterTime);
};

export const isWeekendDays = (specialSessionsData) => {
  const weekend = isSpecialSession(specialSessionsData) ? [] : ["Sat", "Sun"];
  const day = dayjs().format("ddd");

  const isWeekend = weekend.includes(day) ? true : false;

  return isWeekend;
};

export const checkHoliday = (holidays, date) => {
  return holidays.filter((item) => item.formattedDate == date).length > 0;
};

export const pickChartPeriods = (token, period, holidays) => {
  let from;
  let to;

  const str = period.split("");

  if (str && str[1] === "D" && str[0]) {
    let maximimDays = parseInt(str[0]);
    let count = 0;

    let d = new Date();

    while (count < maximimDays) {
      let day = d.getDay();

      var isWeekend = day === 6 || day === 0;

      var holiday = isHolidayDate(d, holidays);

      if ((!isWeekend && !holiday) || isSpecialSession()) {
        count = count + 1;
      }

      if (count === 1 && !to) {
        to = new Date(d.getTime());
      }

      d.setDate(d.getDate() - 1);
    }

    d.setDate(d.getDate() + 1);

    from = d;
  } else if (str && str[1] === "M" && str[0]) {
    let d = new Date();

    to = d;

    from = new Date();
    from.setMonth(from.getMonth() - parseInt(str[0]));
  } else if (str && str[1] === "Y" && str[0]) {
    let d = new Date();

    to = d;

    from = new Date();
    from.setFullYear(from.getFullYear() - parseInt(str[0]));
  }

  return {
    to: getFormattedDateReturn(to),
    from: getFormattedDateReturn(from),

    isholiday:
      holidays &&
      Object.keys(holidays).length > 0 &&
      holidays.filter(
        (item) =>
          dayjs(item.formattedDate).format("YYYY-MM-DD") ===
          dayjs().format("YYYY-MM-DD")
      ).length > 0,

    isWeekend: isWeekendDays(),
  };
};

export const pickChartPeriodsForAllDates = (token, period, holidays) => {
  let from;
  let to;

  const str = period.split("");

  let maximimDays = parseInt(str[0]);

  let dates = [dayjs().format("YYYY-MM-DD")];

  for (let i = 1; i < 8; i++) {
    const day = dayjs().subtract(i, "day");

    const weekday = day.day();

    const isWeekend = weekday === 6 || weekday === 0;

    const holiday = isHolidayDate(day.toDate(), holidays);

    if (!isWeekend && !holiday) {
      dates.push(day.format("YYYY-MM-DD"));
    }
  }

  dates.sort((a, b) => new Date(a) - new Date(b));

  const newDates = dates.filter((item) => {
    const weekDay = dayjs(item).format("dddd");

    const isWeekend = weekDay === "Sunday" || weekDay === "Saturday";

    if (!isWeekend) {
      return item;
    }
  });

  const holydayDate = holidays.filter((item) => {
    if (item.formattedDate == dayjs().format("YYYY-MM-DD")) {
      return item.formattedDate;
    }
  });

  if (holydayDate.length > 0) {
    const index = newDates.indexOf(holydayDate[0].formattedDate);

    newDates.splice(index, 1);
  }

  return {
    dates: newDates.slice(newDates.length - maximimDays, newDates.length),

    isholiday:
      holidays &&
      Object.keys(holidays).length > 0 &&
      holidays.filter(
        (item) =>
          dayjs(item.formattedDate).format("YYYY-MM-DD") ===
          dayjs().format("YYYY-MM-DD")
      ).length > 0,
  };
};

export const getArrayOfDatesBetween = (start_date, end_date) => {
  const diff = dayjs(end_date).diff(dayjs(start_date), "day") + 1;

  const dates = [];

  for (let i = 0; i < diff; i++) {
    const nextDate = dayjs(start_date).add(i, "day");

    const isWeekEndDay = nextDate.day() === 6 || nextDate.day() === 0;

    if (!isWeekEndDay) {
      dates.push(nextDate.format("YYYY-MM-DD"));
    }
  }

  return dates;
};

export const isSpecialSession = (specialSessionsData) => {
  let isday = "";

  if (specialSessionsData && Array.isArray(specialSessionsData)) {
    const filterDate = specialSessionsData.filter(
      (item) => item.formattedDate === dayjs().format("YYYY-MM-DD")
    );
    if (filterDate.length > 0) {
      isday = dayjs(filterDate[0].formattedDate).format("ddd");
    }
    return isday;
  }

  const specialSessionData = getLocal("specialSession");

  if (specialSessionData) {
    const filterDate = specialSessionData?.filter(
      (item) => item.formattedDate === dayjs().format("YYYY-MM-DD")
    );

    if (filterDate.length > 0) {
      isday = dayjs(filterDate[0].formattedDate).format("ddd");
    }
  }

  return isday;
};

export const configSessionForChart = () => {
  let session = "0915-1530";

  const specialSessionData = getLocal("specialSession");

  if (specialSessionData) {
    const filterDate = specialSessionData?.filter(
      (item) => item.formattedDate === dayjs().format("YYYY-MM-DD")
    );

    if (filterDate.length > 0) {
      const isday = dayjs(filterDate[0].formattedDate).format("ddd");

      if (isday === "Mon") session = "0915-1530|0915-1530:2";
      if (isday === "Tue") session = "0915-1530|0915-1530:3";
      if (isday === "Wed") session = "0915-1530|0915-1530:4";
      if (isday === "Thu") session = "0915-1530|0915-1530:5";
      if (isday === "Fri") session = "0915-1530|0915-1530:6";
      if (isday === "Sat") session = "0915-1530|0915-1530:7";
      if (isday === "Sun") session = "0915-1530|0915-1530:1";
    }
  }

  return session;
};